import { render, staticRenderFns } from "./taskDetailDlg.vue?vue&type=template&id=9375c29c&scoped=true"
import script from "./taskDetailDlg.vue?vue&type=script&lang=js"
export * from "./taskDetailDlg.vue?vue&type=script&lang=js"
import style0 from "./taskDetailDlg.vue?vue&type=style&index=0&id=9375c29c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9375c29c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9375c29c')) {
      api.createRecord('9375c29c', component.options)
    } else {
      api.reload('9375c29c', component.options)
    }
    module.hot.accept("./taskDetailDlg.vue?vue&type=template&id=9375c29c&scoped=true", function () {
      api.rerender('9375c29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/task/dialog/taskDetailDlg.vue"
export default component.exports